<template>
  <div class="card-content">
    <v-list-item @click="handleRowClick(item,index)">
      <v-list-item-avatar
        style="max-width: 94.11px;max-height: 94.11px;"
        size="large"
        rounded
        color="#a8a8a8"
      >
        <v-list-item-content class="time-span">
          <v-img
            v-if="isError"
            max-height="128"
            max-width="128"
            contain
            :src="accountImage"
          >
          </v-img>
          <v-img
            v-else
            max-height="128"
            max-width="128"
            :src="avatar"
            :lazy-src="accountImage"
            @error="handleError"
          ></v-img>
        </v-list-item-content>
      </v-list-item-avatar>
      <v-row>
        <v-col
          :cols="12"
        >
          <div> {{ item.userRecord.fullName }} </div>
          <div v-if="isAbnormal">
            {{ item.center.description }}
          </div>
          <div>
            {{ formatDate(item.attendanceDate)
            }}
          </div>
          <div>
            <span>{{ checkinDateTime }}~</span>
            <span :style="isAbnormal?'color:red':''">{{ checkoutDateTime }}</span>
            <span
              v-if="isAbnormal"
              style="color:red"
            >*</span>
          </div>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>
<script setup>
import { computed, ref, toRefs, onMounted, watch } from 'vue'
import { formatDate, formatTime } from '@/utils/helper'

const isError = ref(false)
function handleError(e) {
  isError.value = true
}

const accountImage = computed(() => require('@/assets/images/AsianAlliance/account-circle.png'))

const props = defineProps({
  item: {
    type: Object,
    default: () => ({ bookingTransfers: [] }),
  },
  index: {
    type: Number,
    default: 0,
  },
})
const { item, index } = toRefs(props)

const checkinDateTime = computed(() => {
  if (item.value.checkinDateTime) {
    return formatTime(item.value.checkinDateTime)
  }

  return ''
})

const isAbnormal = computed(() => item.value.coachAttendanceAbnormal && !item.value.checkoutDateTime)

const checkoutDateTime = computed(() => {
  if (item.value.checkoutDateTime) {
    return formatTime(item.value.checkoutDateTime)
  }
  if (item.value.coachAttendanceAbnormal && item.value.coachAttendanceAbnormal.checkoutDateTime) {
    return formatTime(item.value.coachAttendanceAbnormal.checkoutDateTime)
  }

  return ''
})

const avatar = computed(() => process.env.VUE_APP_BASE_API + item.value.userRecord.avatar || 'https://cdn.vuetifyjs.com/images/lists/1.jpg')

const error = ref(false)

const emit = defineEmits(['click'])

function handleRowClick(item, index) {
  console.log('handleRowClick', item, index)
  emit('click', item, index)
}
</script>
  <style scoped>

  .time-span {
    color: white
  }
  </style>
